import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "line__item"
};
const _hoisted_2 = { class: "text text--sm text--placeholder" };
import { computed, onMounted, ref, watch } from "vue";
import { useDeliveryApi } from "../../../../api/deliveryApi";
import EventBus from "../../../../events/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryMethodsNotice',
    props: {
        address: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        watch(() => props.address, updateList);
        const names = {
            pickpoint: 'PickPoint',
            fivepost: '5Post',
            post: 'Почтой России',
            courier: 'Курьером',
            cdek: 'СДЭК',
        };
        const currentCity = ref();
        const deliveryList = ref();
        const visibleDeliveryList = computed(() => {
            const result = [];
            if (deliveryList.value) {
                for (const key in deliveryList.value) {
                    if (key === props.address.delivery.name || !deliveryList.value[key].available) {
                        continue;
                    }
                    result.push(names[key]);
                }
            }
            return result;
        });
        const loading = ref(false);
        function updateList() {
            if (loading.value || currentCity.value === props.address.cityFias && deliveryList.value || (!props.address.cityFias || !props.address.region)) {
                return;
            }
            loading.value = true;
            deliveryList.value = {};
            useDeliveryApi().getDeliveryInfo(props.address.region, props.address.cityFias, props.address.zipCode, false, props.address.beltway)
                .then(result => {
                loading.value = false;
                deliveryList.value = result.services;
                currentCity.value = props.address.cityFias;
                EventBus.emit('order:delivery-list-updated', result.services);
            });
        }
        onMounted(updateList);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "line__item" }, {
                default: _withCtx(() => [
                    (visibleDeliveryList.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[0] || (_cache[0] = _createTextVNode("\n        Другие способы доставки: ", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDeliveryList.value, (item) => {
                                    return (_openBlock(), _createElementBlock("strong", { key: item }, _toDisplayString(item), 1 /* TEXT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
